/**
 * createElement()
 *
 * Creates an HTML element with the specified attributes and children.
 *
 * @param {string} tag - The tag name of the element to create.
 * @param {Object} [attributes={}] - An object containing key-value pairs of attributes to set on the created element.
 * @param {Array} [children=[]] - An array of child elements or text to append to the created element.
 * @param {string|HTMLElement} [html=''] - A string of HTML content to set as the innerHTML of the created element.
 * @returns {HTMLElement} The created HTML element with the specified attributes, children, and innerHTML.
 */
export function createElement(
    tag,
    attributes = {},
    children = [],
    html = "",
    eventListeners = {}
) {
    const element = document.createElement(tag);
    for (const [key, value] of Object.entries(attributes)) {
        element.setAttribute(key, value);
    }
    children.forEach((child) => element.append(child));
    if (html) {
        element.innerHTML = html instanceof HTMLElement ? html.outerHTML : html;
    }
    for (const [eventName, listener] of Object.entries(eventListeners)) {
        element.addEventListener(eventName, listener);
    }
    return element;
}
